import { Box, HStack, Text, VStack, Menu, MenuButton, MenuList, MenuItem, IconButton } from '@chakra-ui/react'
import { FiMoreVertical, FiTrash2, FiEye, FiEdit2 } from 'react-icons/fi';
import { ButtonLink } from '../navbar/ButtonLink';
import { WorkflowTextService } from '@/shared/WorkflowTextService';
import { TEMPLATE } from '@/shared/constants';
import { DeleteConfirmationDialog } from '../dashboard/DeleteConfirmationDialog';
import { RenameTemplateDialog } from './RenameTemplateDialog';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

export const PageTemplateBox = (props: {
  templateId: string
  onDeletePage: (templateId: string) => Promise<void>
  onRenamePage: (oldId: string, newId: string) => Promise<void>
}) => {
  const navigate = useNavigate();
  const isBuiltIn = Object.values(TEMPLATE).includes(props.templateId as TEMPLATE);
  const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] = React.useState(false);
  const [isRenameDialogOpen, setIsRenameDialogOpen] = React.useState(false);

  return (
    <Box w='lg' borderWidth={{ base: '0', md: '1px' }} p={{ base: '0', md: '2' }} borderRadius="md">
      <HStack justify='space-between' px='2' spacing='4'>
        <VStack align='start' spacing='0' flex='1' minWidth={0}>
          <Link to={`/page/${props.templateId}`} style={{ width: '100%' }}>
            <Text fontWeight={600} textDecoration='underline' isTruncated maxW='100%'>{props.templateId}</Text>
          </Link>
          <Text color='fg.subtle' isTruncated maxW='100%'>{WorkflowTextService.getTemplateDescription(props.templateId)}</Text>
        </VStack>
        <HStack spacing='4' flex='none'>
          <ButtonLink to={`/admin/page/${props.templateId}`}>Edit</ButtonLink>
          <Menu>
            <MenuButton
              as={IconButton}
              aria-label='Options'
              icon={<FiMoreVertical />}
              variant='outline'
            />
            <MenuList>
              <MenuItem icon={<FiEye />} onClick={() => navigate(`/page/${props.templateId}`)}>
                View
              </MenuItem>
              <MenuItem icon={<FiEdit2 />} isDisabled={isBuiltIn} onClick={() => setIsRenameDialogOpen(true)}>
                Rename
              </MenuItem>
              <MenuItem isDisabled={isBuiltIn} icon={<FiTrash2 />} onClick={() => setIsDeleteConfirmationOpen(true)}>
                Delete
              </MenuItem>
            </MenuList>
          </Menu>
        </HStack>
      </HStack>
      {isDeleteConfirmationOpen && <DeleteConfirmationDialog
        title='Delete Page Template'
        description={`The page template "${props.templateId}" will be deleted to the recycling bin. Are you sure?`}
        data={props.templateId}
        onDelete={props.onDeletePage}
        onClose={() => setIsDeleteConfirmationOpen(false)}
      />}
      {isRenameDialogOpen && <RenameTemplateDialog
        onClose={() => setIsRenameDialogOpen(false)}
        templateId={props.templateId}
        onRename={props.onRenamePage}
      />}
    </Box>
  );
}